import * as React from 'react';
import { Popper, Grow, Paper, ClickAwayListener, MenuList, MenuItem } from '@material-ui/core';
import { IAuthState } from 'src/modules/Auth/store/types';
import { IReduxState } from 'src/reduxTypes';
import { connect } from 'react-redux';
import { IProvider } from 'src/share/types/provider';
import './providerFilter.css';

export interface IProviderFilterProps {
  auth: IAuthState
  changeProvider: (provider: string) => void;
  providers: IProvider[];
  selected: string;
}

export interface IProviderFilterState {
  selected: string;
  toggleFilter: boolean;
}

class ProviderFilter extends React.Component<IProviderFilterProps, IProviderFilterState> {
  constructor(props: IProviderFilterProps) {
    super(props);
    this.state = {
      selected: props.selected,
      toggleFilter: false
    }
  }
  public toggleFilter = (selected?) => {
    this.setState((state) => ({
      toggleFilter: !state.toggleFilter,
      selected: typeof selected === "string" ? selected : state.selected
    }))
  }
  public changeProvider = (provider) => () => {
    this.toggleFilter(provider);
    this.props.changeProvider(provider);
  }
  public render() {
    const { providers } = this.props;
    const providerSelected = providers.find(provider => provider.providerId === this.state.selected);
    return (
      <h3 className={'providerFilter'}>
        {
          this.state.selected === 'ALL' || !providerSelected ? 'PROVIDER' : providerSelected.name}
        <div className={"filter"}>
          <p onClick={() => this.setState({ toggleFilter: true })}>
            <i className="fa fa-filter" aria-hidden="true" />
            Filter
        </p>
          <Popper className="filterPopper" open={this.state.toggleFilter} transition={true} disablePortal={true}>
            {({ TransitionProps, placement }) => (
              <Grow
                {...TransitionProps}
                style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom' }}
              >
                <Paper>
                  <ClickAwayListener onClickAway={this.toggleFilter}>
                    <MenuList>
                      <MenuItem onClick={this.changeProvider('ALL')}>ALL</MenuItem>
                      {(providers).map((provider) =>
                        <MenuItem onClick={this.changeProvider(provider.providerId)} key={provider.providerId}>{provider.name}</MenuItem>
                      )}
                    </MenuList>
                  </ClickAwayListener>
                </Paper>
              </Grow>
            )}
          </Popper>
        </div>
      </h3>
    );
  }
}
const mapStateToProps = (state: IReduxState) => ({
  auth: state.auth
});

export default connect(mapStateToProps)(ProviderFilter);